import React from 'react'
import { Account } from '@ally/data-types-afg-accounts'
import { Box } from '@ally/metronome-ui'
import { asCurrency } from '@ally/aos-utils'
import MobileCardDetail from './MobileCardDetail'
import {
  isAutoAccountWithNoActiveVehicle,
  isPastDueUnavailable,
} from '../Vehicles/utils'
import {
  StyledAccountDetailsLink,
  TotalBalanceContainer,
} from './SharedMobileCardStyles'
import { mobileAccountCardAllyTM } from '../../utils'

const TotalAvailableBalance: React.FC<{
  accounts: Account[]
}> = ({ accounts }) => {
  const accountsWithActiveVehicle = accounts.filter(
    account => !isPastDueUnavailable(account),
  )
  const total = accountsWithActiveVehicle.reduce(
    (sum: number, account: Account) =>
      (account.meta?.nextPayment?.totalAmountDue ?? 0) + sum,
    0,
  )

  const totalAmount =
    accountsWithActiveVehicle.length > 0 ? asCurrency(total) : 'Unavailable'

  return (
    <TotalBalanceContainer>
      <Box fontWeight="bold">Total</Box>
      <Box fontWeight="bold">{totalAmount}</Box>
    </TotalBalanceContainer>
  )
}

const MobileVehicleAccountList: React.FC<{
  accounts: Account[]
}> = ({ accounts }) => {
  return (
    <>
      {accounts.map((account: Account) => {
        const key = `detail-${account.id}`
        const content = <MobileCardDetail account={account} />

        return (
          <StyledAccountDetailsLink
            account={account}
            text={content}
            key={key}
            showAsText={isAutoAccountWithNoActiveVehicle(account)}
            allytm={mobileAccountCardAllyTM(account)}
          />
        )
      })}
      <TotalAvailableBalance accounts={accounts} />
    </>
  )
}

export default MobileVehicleAccountList
